"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatchedVariantUpdateSuggestionRequest = instanceOfPatchedVariantUpdateSuggestionRequest;
exports.PatchedVariantUpdateSuggestionRequestFromJSON = PatchedVariantUpdateSuggestionRequestFromJSON;
exports.PatchedVariantUpdateSuggestionRequestFromJSONTyped = PatchedVariantUpdateSuggestionRequestFromJSONTyped;
exports.PatchedVariantUpdateSuggestionRequestToJSON = PatchedVariantUpdateSuggestionRequestToJSON;
exports.PatchedVariantUpdateSuggestionRequestToJSONTyped = PatchedVariantUpdateSuggestionRequestToJSONTyped;
const kindEnum_1 = require("./kindEnum");
const variantInVariantUpdateSuggestionRequest_1 = require("./variantInVariantUpdateSuggestionRequest");
/**
 * Check if a given object implements the PatchedVariantUpdateSuggestionRequest interface.
 */
function instanceOfPatchedVariantUpdateSuggestionRequest(value) {
    return true;
}
function PatchedVariantUpdateSuggestionRequestFromJSON(json) {
    return PatchedVariantUpdateSuggestionRequestFromJSONTyped(json, false);
}
function PatchedVariantUpdateSuggestionRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'kind': json['kind'] == null ? undefined : (0, kindEnum_1.KindEnumFromJSON)(json['kind']),
        'variants': json['variants'] == null ? undefined : (json['variants'].map(variantInVariantUpdateSuggestionRequest_1.VariantInVariantUpdateSuggestionRequestFromJSON)),
        'issue': json['issue'] == null ? undefined : json['issue'],
        'solution': json['solution'] == null ? undefined : json['solution'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
function PatchedVariantUpdateSuggestionRequestToJSON(json) {
    return PatchedVariantUpdateSuggestionRequestToJSONTyped(json, false);
}
function PatchedVariantUpdateSuggestionRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'kind': (0, kindEnum_1.KindEnumToJSON)(value['kind']),
        'variants': value['variants'] == null ? undefined : (value['variants'].map(variantInVariantUpdateSuggestionRequest_1.VariantInVariantUpdateSuggestionRequestToJSON)),
        'issue': value['issue'],
        'solution': value['solution'],
        'comment': value['comment'],
    };
}
//# sourceMappingURL=patchedVariantUpdateSuggestionRequest.js.map